import { render, staticRenderFns } from "./EmailBroadcastCanSpamModal.vue?vue&type=template&id=0709fed4&scoped=true"
import script from "./EmailBroadcastCanSpamModal.vue?vue&type=script&lang=js"
export * from "./EmailBroadcastCanSpamModal.vue?vue&type=script&lang=js"
import style0 from "./EmailBroadcastCanSpamModal.vue?vue&type=style&index=0&id=0709fed4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0709fed4",
  null
  
)

export default component.exports